const getters = {
  paginate_comments_ticket: (state) => state.paginate_comments_ticket,
  pagination_comments_ticket: (state) => state.pagination_comments_ticket,
}

export default getters
